import axios from "../../privateApi";

export type PutUserSbcSolutionPlayer = {
  resourceId: number;
  eaPlayerId?: number;
};

export type PutUserSbcSolutionBody = {
  players: PutUserSbcSolutionPlayer[];
};

export const putUserSbcSolution = (
  setId: number,
  sbcId: number,
  body: PutUserSbcSolutionBody,
) => axios.put<void>(`/user-sbc-solutions/${setId}/${sbcId}`, body);
